import { useTranslation } from 'react-i18next';
import ImgErrorNetwork from '../../assets/images/ErrorNetwork';
import ImgErrorNotFound from '../../assets/images/ErrorNotFound';
import ImgErrorPermission from '../../assets/images/ErrorPermission';
import React from 'react';

export default function ErrorPage(props ={}) {
  const { t } = useTranslation();
  const pageType = props.type || 'permission';

  return (
    <div className='error-page'>
      <div className='error-icon'>
        {pageType === 'network' && <ImgErrorNetwork className='icon' />}
        {pageType === 'permission' && <ImgErrorPermission className='icon' />}
        {pageType === 'notFound' && <ImgErrorNotFound className='icon' />}
      </div>
      <h1>{t(`error.${props.type}.title`)}</h1>
      <p>{t(`error.${props.type}.content`)}</p>
    </div>
  );
}